






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { auctionModule, snackModule } from '@/store';
import { Auction } from '@/api';
import SingleAuction from '@/components/frontend/SingleAuction.vue';
import moment from 'moment';

@Component({
  components: { SingleAuction },
})
export default class extends Vue {
  loadingAuctions: boolean = false;

  auctions: Auction[] = [];
  comingAuctions: Auction[] = [];
  pastAuctions: Auction[] = [];

  async mounted() {
    try {
      const currentDate = new Date().toISOString();
      this.loadingAuctions = true;
      this.auctions = (
        await Auction.includes(['images'])
          .where({ status: 'current' })
          .order({ date: 'asc' })
          .all()
      ).data;
      this.comingAuctions = (
        await Auction.includes(['images'])
          .where({ status: 'future' })
          .all()
      ).data;
      this.pastAuctions = (
        await Auction.includes(['images'])
          .where({ status: 'past' })
          .order({ date: 'desc' })
          .all()
      ).data;
    } catch (e) {
      // Error
    } finally {
      this.loadingAuctions = false;
    }
  }
}
